// extracted by mini-css-extract-plugin
export default {"wrapper":"Conversation_wrapper__9xiLm"};